module.exports = __webpack_public_path__ + "static/media/finkraft-logo.5f8697e7.svg";